/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  /** cart code **/

var isCartPage = document.getElementById('your-shopping-cart');

// Function to check if the element is visible
function checkVisibility() {
    const cartDrawer = document.getElementById('cart-drawer');
    if ((cartDrawer && cartDrawer.offsetWidth > 0 && cartDrawer.offsetHeight > 0)||isCartPage) {
      if ( document.querySelector('.cart__total__money') ) {
        // Element is visible
        //console.log('Cart drawer is visible');
        // Trigger a custom event
        const event = new CustomEvent('cartDrawerVisible');
        document.dispatchEvent(event);
      }
    }
}

// Create a MutationObserver to monitor changes in the DOM
const observer = new MutationObserver(() => {
    checkVisibility();
});

// Start observing the body for added nodes
observer.observe(document.body, { childList: true, subtree: true });

// Listen for your custom event
document.addEventListener('cartDrawerVisible', function() {
    // Handle the event
    var cartTotal = parseFloat(document.querySelector('.cart__total__money').innerText.replace('$', '').replace(',', '').replace(' USD', ''));
    if ( cartTotal > 749.99 ) {
      document.getElementById('confirmation_label').style.display = 'flex';
    } else {
      document.getElementById('confirmation_label').style.display = 'none';
      document.getElementById('confirmation_warning').style.display = 'none';
    }
});




  
document.body.addEventListener('click', function(event) {
    if (event.target.matches('.cart__checkout.btn')) {
        
        var cartTotal = parseFloat(document.querySelector('.cart__total__money').innerText.replace('$', '').replace(',', '').replace(' USD', ''));
        var isChecked = document.getElementById('confirmation_checkbox').checked;
        
        if (cartTotal > 749.99 && !isChecked) {
            event.preventDefault();
            document.getElementById('confirmation_warning').style.display = 'flex';
            alert('Please confirm your understanding of the cart total before proceeding.');
        }
    }
});







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
